import { render } from "./enterpriseAllocation.vue?vue&type=template&id=534d9ae0&scoped=true"
import script from "./enterpriseAllocation.vue?vue&type=script&lang=js"
export * from "./enterpriseAllocation.vue?vue&type=script&lang=js"

import "./enterpriseAllocation.vue?vue&type=style&index=0&id=534d9ae0&scoped=true&lang=css"
import "./enterpriseAllocation.vue?vue&type=style&index=1&id=534d9ae0&lang=css"
script.render = render
script.__scopeId = "data-v-534d9ae0"

export default script